"use client";
import React from "react";
import HeroWImage from "@/library/sections/heroes/HeroWImage";

export default function HeroWImageBlock({ blok }) {

  const mappedImages =
    blok.images?.map((img) => ({
      src: `${img.filename}/m/1000x400`,
      alt: img.alt || "Hero image",
    })) || [];

  return (
    <HeroWImage
      blok={blok}
      title={blok.title}
      titleAs={blok.titleAs}
      titleColor={blok.titleColor}
      content={blok.content}
      contentColor={blok.contentColor}
      images={mappedImages}
      buttons={blok.buttons || []}
      hasButtons={blok.hasButtons}
    />
  );
}
